/**
 * biddingGcUtils.js - Shared utility for bidding GC transformations
 * Single source of truth for converting between gc IDs and full bidding_gcs objects
 */

/**
 * Build a bidding_gcs array from selected GC IDs, preserving existing submission data.
 * @param {string[]} gcIds - Selected GC IDs
 * @param {Array} existingGCs - Existing bidding_gcs with submission data to preserve
 * @param {Array} generalContractors - Full GC list from settings (for name lookup)
 * @returns {Array} Complete bidding_gcs array
 */
export const buildBiddingGCs = (gcIds, existingGCs = [], generalContractors = []) => {
  return gcIds.map((gcId) => {
    const existing = existingGCs.find((gc) => gc.gc_id === gcId);
    if (existing) return existing;
    const gc = generalContractors.find((g) => g.id === gcId);
    return {
      gc_id: gcId,
      gc_name: gc?.name || "",
      bid_sent_date: "",
      bid_sent_time: "",
      bid_not_sent: false,
    };
  });
};

/**
 * Get a display-friendly client name from bidding GCs.
 * @param {Array} biddingGCs - The bidding_gcs array
 * @returns {string} Comma-joined GC names
 */
export const getBiddingGCsDisplayName = (biddingGCs) => {
  return biddingGCs.map((gc) => gc.gc_name).filter(Boolean).join(", ");
};
